import { render, staticRenderFns } from "./booking-clinic-filters.vue?vue&type=template&id=dcdc881e&"
import script from "./booking-clinic-filters.vue?vue&type=script&lang=js&"
export * from "./booking-clinic-filters.vue?vue&type=script&lang=js&"
import style0 from "./booking-clinic-filters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports